import { render, staticRenderFns } from "./editContractDetails.vue?vue&type=template&id=5416cefb&"
import script from "./editContractDetails.vue?vue&type=script&lang=ts&"
export * from "./editContractDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports